import * as Sentry from '@sentry/browser'

export default {
  async install(app, options) {
    const sentryInstance = Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      replaysSessionSampleRate: import.meta.env.VITE_REPLAYS_SESSION_SAMPLE_RATE ?? 0.1,
      replaysOnErrorSampleRate: import.meta.env.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1.0,
      integrations: [Sentry.replayIntegration({})],
    })

    app.provide('$sentry', sentryInstance)
  },
}
